/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3 21.0001H21M3 15.0001H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13 3.00006L21 3.00006M13 9.00006L21 9.00006M9 6.00006C9 7.65692 7.65685 9.00006 6 9.00006C4.34315 9.00006 3 7.65692 3 6.00006C3 4.34321 4.34315 3.00006 6 3.00006C7.65685 3.00006 9 4.34321 9 6.00006Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M3 21.0001H21M13 3.00006L21 3.00006M13 9.00006L21 9.00006M3 15.0001H21M9 6.00006C9 7.65692 7.65685 9.00006 6 9.00006C4.34315 9.00006 3 7.65692 3 6.00006C3 4.34321 4.34315 3.00006 6 3.00006C7.65685 3.00006 9 4.34321 9 6.00006Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M3 21H21M13 3L21 3M13 9L21 9M3 15H21M9 6C9 7.65686 7.65685 9 6 9C4.34315 9 3 7.65686 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M13 3.00006L21 3.00006M13 9.00006L21 9.00006M6 21.0001H3M21 21.0001H10M18 15.0001H21M3 15.0001H14M9 6.00006C9 7.65692 7.65685 9.00006 6 9.00006C4.34315 9.00006 3 7.65692 3 6.00006C3 4.34321 4.34315 3.00006 6 3.00006C7.65685 3.00006 9 4.34321 9 6.00006Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3.00024 21.0001H21.0002M13.0002 3.00006L21.0002 3.00006M13.0002 9.00006L21.0002 9.00006M3.00024 15.0001H21.0002M9.00024 6.00006C9.00024 7.65692 7.6571 9.00006 6.00024 9.00006C4.34339 9.00006 3.00024 7.65692 3.00024 6.00006C3.00024 4.34321 4.34339 3.00006 6.00024 3.00006C7.6571 3.00006 9.00024 4.34321 9.00024 6.00006Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M3 21H21M13 3L21 3M13 9L21 9M3 15H21M9 6C9 7.65686 7.65685 9 6 9C4.34315 9 3 7.65686 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
